import { useState, useEffect } from "react";
import { Divider } from "primereact/divider";
import { Link } from "react-router-dom";
import { CountryService } from "../../services/CountryService";
import { AddPageHeader } from "../Common/Utils";
import JobsAndInternshipsTable from "../Common/JobsAndInternshipsTable";

const JobsAndInternships = () => {
  const [jobs, setJobs] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getJobsAndInternships().then((data) => setJobs(data));
  }, []);

  return (
    <div>
      {AddPageHeader("Consular jobs and internships")}
      <div className="reduce-width">
        <Divider align="center">
          <h1>Consular jobs and internships</h1>
        </Divider>
        <div className="privacy-terms">
          This page features a non-exhaustive selection of consular jobs and
          internships. Are you a governmental body interested in highlighting
          available roles? Please feel free to{" "}
          <Link
            to="/contact"
            style={{
              color: "black",
              fontWeight: "bold",
            }}
          >
            contact
          </Link>{" "}
          the Center.
          <br />
          <JobsAndInternshipsTable data={jobs} searchEnabled longDescription />
        </div>
      </div>
    </div>
  );
};

export default JobsAndInternships;
